/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'

export default function PromiseUnit(props) {
    return (
        <div className="item p-3">
            {props.icon}
            <div className="wrap">
                <h5>{props.title}</h5>
                <p>{props.des1}</p>
                <p>{props.des2}</p>
            </div>
        </div>
    )
}
